import axios from 'axios';
import authHeader from './auth-header';
const API_URL = process.env.REACT_APP_URL_API;

class CaptchaService {

    validCaptcha(response) {
        return axios.post(API_URL + "recaptcha/valid", {
            response
        },{ headers: authHeader() });

    }

    validCaptchaUpdate(response,email) {
        return axios.post(API_URL + "update/recaptcha/valid", {
            response,
            email
        },{});

    }


    validCaptchaChangePwd(response,pwd,id,pwdcurrent) {
        return axios.post(API_URL + "change/pwd", {
            response,
            pwd,
            id,
            pwdcurrent
        },{});

    }


}

export default new CaptchaService();
